import React, { ReactElement } from 'react';

import { useListContextRequired, useMassUpdateServiceRequired } from 'ui-builder';
import SelectAllCheckbox from './SelectAllCheckbox';
import styles from './MassUpdateControlsLayout.module.scss';

export interface MassUpdateControlsLayoutProps {
  children: ListOrSingle<ReactElement | false>;
  hideSelectAll?: boolean;
}

function Separator() {
  return (
    <div className={styles.separator}>
      &nbsp;
    </div>
  );
}

export default function MassUpdateControlsLayout(props: MassUpdateControlsLayoutProps) {
  const massUpdateService = useMassUpdateServiceRequired();

  const listContext = useListContextRequired();

  const display = (listContext.data && listContext.data.length > 0) || !props.hideSelectAll;

  if (massUpdateService.isEnabled() && display) {
    return (
      <div className={styles.block}>
        {!props.hideSelectAll && <SelectAllCheckbox />}
        {!props.hideSelectAll && <Separator />}
        <div className={styles.buttons}>
          {props.children}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
